import React, { useEffect } from "react";
import { useDispatch } from 'react-redux';
import apiService from "../services/api.service";
import { Dialog } from "primereact/dialog";
import { actionsDeliveriesByApp } from '../store/reports/deliveriesByApp';
import moment from "moment";

import './notification.scss';

const NotificationButton = () => {
    const dispatch = useDispatch();

    const [total, setTotal] = React.useState(0);
    const [isOpen, setIsOpen] = React.useState(false);
    const [notification, setNotification] = React.useState(null);
    const [notifications, setNotifications] = React.useState([]);
    const [notificationisOpen, setNotificationIsOpen] = React.useState(false);

    useEffect(() => {
        menuGetNotification();
    }, []);

    useEffect(() => {
        if (notifications) {
            const newNotifications = notifications.filter(notif => notif.status === "NEW");
            setTotal(newNotifications.length);
            handleDeliveriesByApp()
        }
    }, [notifications]);

    // getNotification
    function menuGetNotification() {
        apiService
            .get("/api/v1/lognex/menus/get/notifications")
            .then(({ data }) => {
                setNotifications(data);
                setTotal(1);
                setTimeout(() => {
                    menuGetNotification()
                }, 5000)
            })
            .catch((err) => {
                console.log(err)
                setNotifications([]);
                setTimeout(() => {
                    menuGetNotification()
                }, 5000)
            })
    }

    function onReadNotification(id) {
        if (id) {
            apiService
                .post(`/api/v1/lognex/menus/read/notification`, { id })
                .then(() => {
                    menuGetNotification();
                })
                .catch((err) => {
                    menuGetNotification()
                })
        }
    }
    function onRemoveNotification(id) {
        if (id) {
            apiService
                .post(`/api/v1/lognex/menus/remove/notification`, { id })
                .then(() => {
                    menuGetNotification()
                })
                .catch((err) => {
                    menuGetNotification()
                })
        }
    }

    const handleNotification = (notif) => {
        let updatedNotif = { ...notif };
        setNotification(updatedNotif);
    };

    const handleDeliveriesByApp = () => {
        dispatch(actionsDeliveriesByApp.load());
    };

    const downloadImage = (occurrence) => {
        var a = document.createElement("a");
        document.body.append(a);
        a.href = occurrence.image;
        // a.download = occurrence.orderCode + "_image.png";
        a.click();
        a.remove();
    }

    return (
        <div className="notification-container">
            <button className="bell-button" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => { setIsOpen(false) }} onClick={() => setIsOpen(!isOpen)}>
                <i className={`pi pi-bell bell-icon ${isOpen ? "clicked" : "no-clicked"}`}></i>
                {total > 0 && <span className="notification-badge">{total}</span>}
            </button>

            {isOpen && (
                <div className="notification-panel" onMouseEnter={() => { setIsOpen(true) }} onMouseLeave={() => { setIsOpen(false) }}>
                    <div className="panel-header">
                        <h4>Avisos</h4>
                        <i className="pi pi-cog"></i>
                    </div>
                    <div className="notification-list">
                        {notifications && notifications.map((notif) => (
                            <React.Fragment key={notif.id}>
                                <div className={`notification-item ${notif?.status === "READ" ? "read" : "no-read"}`}>
                                    {notif?.image != "" && (<img src={notif?.image} alt="Produto" className="notification-image" />)}
                                    <div className="notification-content" onClick={() => {
                                        setNotificationIsOpen(true);
                                        handleNotification(notif)
                                    }}
                                       title="Clique para ver a ocorrência"  
                                    >
                                        <p>{notif.orderCode}</p>

                                        {notif.vehiclePlate && (<p style={{ color: "red" }}>Veículo: {notif.vehiclePlate}</p>)}
                                        <p>Data: {notif.date}</p>
                                    </div>
                                    <div className="notification-button">
                                        <button 
                                            className="check" 
                                            title="Marcar como lido"
                                            onClick={(e) => {
                                                onReadNotification(notif.id)
                                            }}
                                        >
                                            <i className="pi pi-check"></i>
                                        </button>
                                        <button 
                                            className="remove" 
                                            title="Remover notificação"
                                            onClick={(e) => {
                                                onRemoveNotification(notif.id)
                                            }}
                                        >
                                            <i className="pi pi-trash" style={{ color: "white" }}></i>
                                        </button>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            )}
            {notificationisOpen && (
                <Dialog
                    header={
                        <div className="lxButtonDialogHeader">
                            <div className="lxHeaderTitle">
                                <i className="pi pi-exclamation-triangle error-icon"> </i>
                                <h3>Notificação</h3>
                            </div>
                            <button
                                className="p-dialog-titlebar-icon p-link lxHeaderClose"
                                onClick={() => {
                                    setNotificationIsOpen(false);
                                    onReadNotification(notification.id);
                                }}
                            >
                                <span className="pi pi-times"></span>
                            </button>
                        </div>
                    }
                    closable={false}
                    visible={notificationisOpen}
                    modal={false}
                    onHide={() => {
                        setNotificationIsOpen(false);
                        onReadNotification(notification.id)
                    }}
                >
                    <div className="detail-occurrence-body">
                        {notification.vehiclePlate && (
                            <p>
                                <strong>Placa do veículo: </strong> {notification.vehiclePlate}
                            </p>
                        )}
                        <p>
                            <strong>Código da ocorrência: </strong> {notification.orderCode}
                        </p>
                        <p>
                            <strong>Descrição da ocorrência: </strong> {notification.message}
                        </p>
                        {/* <p>
                            <strong>Descrição: </strong> {notification.description}
                        </p> */}
                        <p>
                            <strong>Data: </strong> {notification.date}
                        </p>
                        {notification?.image && (
                            <React.Fragment>
                                <button title="Baixar imagem" onClick={() => { downloadImage(notification) }}><i className="pi pi-download"></i></button>
                                <div className="detail-occurrence-image-container">
                                    <div className="detail-occurrence-image">
                                        <img title="Baixar imagem" onClick={() => { downloadImage(notification) }} className="image" src={notification.image} />
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </Dialog>
            )}
        </div>
    );
};

export default NotificationButton